export const REGULAR_DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_FORMAT = 'DD-MM-YYYY';
export const REVERSE_DATE_FORMAT = 'YYYY-MM-DD';
export const FULL_DATE_FORMAT = 'DD/MM/YYYY hh:mm:ss a';
export const DATE_FORMAT_SLASH_00 = 'YYYY-MM-DD 00:00:00.000';
export const DATE_FORMAT_SLASH_59 = 'YYYY-MM-DD 24:59:59.000';
export const DATE_FORMAT_DATE_PICKER = 'DD MMMM YYYY';
export const DATE_FORMAT_COLUMN_TABLE = 'DD [de] MMMM [de] YYYY HH:mm';
export const DATE_FORMAT_IN_TEXT = 'DD [de] MMMM [de] YYYY';
export const DATE_FORMAT_IN_TEXT_EXPLICIT = 'DD [de mes] MMMM [de año] YYYY';
export const FORMAT_BACKEND = 'YYYYMMDDHHmmss';
export const DATE_BACKEND = 'YYYYMMDD';
export const HOUR_FORMAT = 'hh:mm a';
export const HOUR_FORMAT_COMPLETE = 'hh:mm:ss a';
export const DATE_BACKEND_DAY = 'YYYYMMDD';
export const DATE_BACKEND_HOUR = 'HHmmss';
export const DATE_FORMAT_SLASH = 'YYYY-MM-DD HH:mm:ss';
